import React, { useContext } from 'react';
import {
	IFirmwareAssignmentContext,
	FirmwareAssignmentContext,
} from '../firmwareAssignmentState/firmwareAssignmentContext';
import { ModalWrapper } from 'components/ModalWindows/ModalWrapper';
import { ModalToConfirm } from 'components/ModalWindows/ModalToConfirm';
import ModalSentSuccessfully from 'components/ModalWindows/ModalSentSuccessfully';
import ModalSentError from 'components/ModalWindows/ModalSentError';

export const ModalWindows: React.FC = () => {
	const { resetChanges, updateModuleDataAfterSaving, changeTypeOfModalWindow, sendChanges, typeOfModalWindow } =
		useContext<IFirmwareAssignmentContext>(FirmwareAssignmentContext);

	const handleConsentEvent = () => {
		resetChanges();
		updateModuleDataAfterSaving();
		changeTypeOfModalWindow(null);
	};

	return (
		<ModalWrapper isVisible={!!typeOfModalWindow}>
			<ModalToConfirm
				onConsentEvent={resetChanges}
				onFailureEvent={() => changeTypeOfModalWindow(null)}
				isVisible={typeOfModalWindow === 'toConfirmFieldsClearing'}
				description="cancelSaveInfo"
			/>
			<ModalToConfirm
				onConsentEvent={sendChanges}
				onFailureEvent={() => changeTypeOfModalWindow(null)}
				isVisible={typeOfModalWindow === 'toConfirmSendChanges'}
				description="saveInfo"
			/>
			<ModalSentSuccessfully
				onConsentEvent={handleConsentEvent}
				isVisible={typeOfModalWindow === 'success'}
				description="savedSuccessfully"
			/>
			<ModalSentError
				onConsentEvent={() => changeTypeOfModalWindow(null)}
				isVisible={typeOfModalWindow === 'error'}
				description="errorWhileSaving"
			/>
			<ModalSentError
				onConsentEvent={() => changeTypeOfModalWindow(null)}
				isVisible={typeOfModalWindow === 'firmwareLimit'}
				description="cannotAssignTwoFirmwares"
			/>
			<ModalSentError
				onConsentEvent={() => changeTypeOfModalWindow(null)}
				isVisible={typeOfModalWindow === 'firmwareOfSameType'}
				description="cannotAssignFirmwareSameType"
			/>
			<ModalSentError
				onConsentEvent={() => changeTypeOfModalWindow(null)}
				isVisible={typeOfModalWindow === 'restaurantAlreadyHasFirmwareTypeMAX'}
				description="maxFirmwarePresented"
			/>
			<ModalSentError
				onConsentEvent={() => changeTypeOfModalWindow(null)}
				isVisible={typeOfModalWindow === 'restaurantAlreadyHasFirmwareTypeAndroid'}
				description="androidFirmwarePresented"
			/>
		</ModalWrapper>
	);
};
